// React
import React from "react";
import { connect } from "react-redux";
import { NavLink as RouterNavLink, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

// material ui
import logo from '../images/Logo4.png';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import {
  Avatar,
  Collapse,
  Grid,
  Chip,
  ListItem,
  ListItemText,
  ListItemIcon,
  Drawer as MuiDrawer,
  List as MuiList,
  Typography,
  IconButton,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import {ExpandLess, ExpandMore, MenuBook, HelpOutline, SettingsOutlined, PeopleOutlined, FolderOpen, Memory} from "@material-ui/icons";
import CodeIcon from '@material-ui/icons/Code';
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";

// custom components
import originalMenu from "../routes/index";
import {Logo} from "../pages/components/Logo";
import GLOBALS from "../services/GLOBALS";
import {redirectTo} from "../routes/functions";
import {AuthService} from "../services/AuthService";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../vendor/perfect-scrollbar.css";
import styled from "styled-components";
import { rgba } from "polished";
import {ExtrasService} from "../services/ExtrasService";
import SupportRequestDialog from "../pages/pages/SupportRequestDialog";
import BrainOptimizationGuidelinePDF from "../Public/BrainOptimizationGuideline.pdf";


let routes = originalMenu.filter(child => !child.hidden);

// Maps route id/name to nav translation key for sidebar labels
const ROUTE_LABEL_KEYS = {
  'Home': 'routes.home',
  'About': 'routes.about',
  'FAQs': 'routes.faqs',
  'User Roles': 'routes.userRoles',
  'User Manual': 'routes.userManual',
  'My Account': 'routes.myAccount',
  'Institutions': 'routes.institutions',
  'Admin Panel': 'routes.adminPanel',
  'Users': 'routes.users',
  'Add user': 'routes.addUser',
  'Records': 'routes.records',
  'Patient': 'routes.patient',
  'Reports': 'routes.reports',
  'Demo Reports': 'routes.demoReports',
  'Training': 'routes.training',
  ' Training Videos': 'routes.trainingVideos',
  'Varjo Headset Videos': 'routes.varjoHeadsetVideos',
  'MAC and All In One Videos': 'routes.macAllInOneVideos',
  'Evaluator Exam': 'routes.evaluatorExam',
  'Certificates': 'routes.certificates',
  'Admin': 'routes.admin',
  'Patient List': 'routes.patientList',
  'Resources': 'sidebar.resources',
  'ABOUT': 'sidebar.about',
  'Brain Optimization Guideline': 'sidebar.brainOptimizationGuideline',
};

const getRouteLabel = (t, idOrName) => {
  const key = ROUTE_LABEL_KEYS[idOrName];
  return key ? t(key) : idOrName;
};

const NavLink = React.forwardRef((props, ref) => (
  <RouterNavLink innerRef={ref} {...props} />
));

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  background-image: linear-gradient(to bottom, #FFFFFF 6.34%, #EEF9FE 77.92%) !important;
`;

const List = styled(MuiList)`
`;

const Items = styled.div`
  padding-top: ${props => props.theme.spacing(2.5)}px;
  padding-bottom: ${props => props.theme.spacing(2.5)}px;
`;

const Brand = styled(ListItem)`
  font-size: ${props => props.theme.typography.h5.fontSize};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
  color: ${props => props.theme.sidebar.header.color};
  background: #FFFFFF 6.34%;
  font-family: ${props => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${props => props.theme.spacing(6)}px;
  padding-right: ${props => props.theme.spacing(6)}px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  

  ${props => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }
`;


const Category = styled(ListItem)`
  padding-top: ${props => props.theme.spacing(3)}px;
  padding-bottom: ${props => props.theme.spacing(3)}px;
  padding-left: ${props => props.theme.spacing(6)}px;
  padding-right: ${props => props.theme.spacing(5)}px;
  font-weight: ${props => props.theme.typography.fontWeightRegular};

  svg {
    color: ${props => props.theme.sidebar.color};
    font-size: 20px;
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: #EEF7FF;
    border-radius: 8px;
  }

  &.${props => props.activeClassName} {

    span {
      color: ${props => props.theme.sidebar.color};
    }
  }
`;

const CategoryText = styled(ListItemText)`
  margin: 0;
  span {
    color: ${props => props.theme.sidebar.color};
    font-size: 16px;
    font-weight: 500;
    padding: 0 ${props => props.theme.spacing(4)}px;
  }
`;

const CategoryIconLess = styled(ExpandLess)`
  color: ${props => rgba(props.theme.sidebar.color, 0.5)};
`;

const CategoryIconMore = styled(ExpandMore)`
  color: ${props => rgba(props.theme.sidebar.color, 0.5)};
`;

const Link = styled(ListItem)`
  padding-left: ${props => props.theme.spacing(14)}px;
  padding-top: ${props => props.theme.spacing(2)}px;
  padding-bottom: ${props => props.theme.spacing(2)}px;

  span {
    color: ${props => rgba(props.theme.sidebar.color, 0.7)};
  }

  &:hover span {
    color: ${props => rgba(props.theme.sidebar.color, 0.9)};
  }

  &.${props => props.activeClassName} {

    span {
      color: ${props => props.theme.sidebar.color};
    }
  }
`;

const LinkText = styled(ListItemText)`
  color: ${props => props.theme.sidebar.color};
  span {
    font-size: ${props => props.theme.typography.body1.fontSize}px;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

const LinkBadge = styled(Chip)`
  font-size: 11px;
  font-weight: ${props => props.theme.typography.fontWeightBold};
  height: 20px;
  position: absolute;
  right: 12px;
  top: 8px;

  span.MuiChip-label,
  span.MuiChip-label:hover {
    cursor: pointer;
    color: ${props => props.theme.sidebar.badge.color};
    padding-left: ${props => props.theme.spacing(2)}px;
    padding-right: ${props => props.theme.spacing(2)}px;
  }
`;

const CategoryBadge = styled(LinkBadge)`
  top: 12px;
`;

const SidebarSection = styled(Typography)`
  color: ${props => props.theme.sidebar.color};
  padding: ${props => props.theme.spacing(4)}px
    ${props => props.theme.spacing(6)}px ${props => props.theme.spacing(1)}px;
  font-weight: 500;
  display: block;
`;

const SidebarFooter = styled.div`
  padding: ${props => props.theme.spacing(3)}px
    ${props => props.theme.spacing(4)}px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  background: #EEF9FE 77.92%;
  &:hover {
    background: #FFFFFF;
    cursor: pointer;
  }

`;

function SidebarCategory({
  name,
  icon,
  classes,
  isOpen,
  isCollapsable,
  badge,
  ...rest
}) {
  return (
    <Category {...rest}>
      {icon}
      <CategoryText>{name}</CategoryText>
      {isCollapsable ? (
        isOpen ? (
          <CategoryIconMore />
        ) : (
          <CategoryIconLess />
        )
      ) : null}
      {badge ? <CategoryBadge label={badge} /> : ""}
    </Category>
  );
}



function SidebarLink({ name, to, badge }) {
  return (
    <Link
      button
      dense
      component={NavLink}
      exact
      to={to}
      activeClassName="active"
    >
      <LinkText>{name}</LinkText>
      {badge ? <LinkBadge label={badge} /> : ""}
    </Link>
  );
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supportDialogOpen: false,
      resourcesOpen: false,
    };
  }
  toggleSupportDialog = () => {
    this.setState(({ supportDialogOpen }) => ({
      supportDialogOpen: !supportDialogOpen
    }));
  };

  toggleResources = () => {
    this.setState(({ resourcesOpen }) => ({
      resourcesOpen: !resourcesOpen
    }));
  };

  handleUserManual = () => {
    return (
      redirectTo('/user_manual')
    );
  };

  handleAbout = () => {
    redirectTo('/about');
  };

  toggle = index => {
    // Collapse all elements
    Object.keys(this.state).forEach(
      item =>
        this.state[index] ||
        this.setState(() => ({
          [item]: false
        }))
    );

    // Toggle selected element
    this.setState(state => ({
      [index]: !state[index]
    }));
  };

  UNSAFE_componentWillMount() {
    /* Open collapse element that matches current url */
    const pathName = this.props.location.pathname;

    routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/" ? true : false;

      this.setState(() => ({
        [index]: isActive || isOpen || isHome
      }));
    });
  }


  render() {
    // Destructure all non-DOM props to prevent them from being spread to <Drawer>.
    // withTranslation injects t, i18n, tReady; connect injects dispatch; withRouter injects history/location/match/staticContext.
    const {
      routes,
      classes,
      staticContext,
      // i18next props injected by withTranslation — must NOT be forwarded to the DOM
      t: tFn,
      i18n: i18nInstance,
      tReady,
      ...other
    } = this.props;

    function handleLogout(){
      AuthService.logout();
      sessionStorage.removeItem(GLOBALS.SESSION_KEYS.TOKEN);
      sessionStorage.removeItem(GLOBALS.SESSION_KEYS.USER);
      sessionStorage.removeItem(GLOBALS.SESSION_KEYS.USER_ID);
      sessionStorage.removeItem(GLOBALS.SESSION_KEYS.USER_ROLES);
      sessionStorage.removeItem(GLOBALS.SESSION_KEYS.EVALUATOR_STATUS);

      redirectTo('/auth/sign-in')
    }


    // This could be simpler but is needed like this to avoid problems with special characters
    function openHtmlInNewWindow(base64Html) {
      // Convert Base64 to binary data
      const binaryData = Uint8Array.from(atob(base64Html), char => char.charCodeAt(0));
      
      // Decode binary data as UTF-8 text
      const decoder = new TextDecoder('utf-8');
      const htmlContent = decoder.decode(binaryData);
      
      // Open the decoded HTML content in a new window
      const newWindow = window.open();
      newWindow.document.write(htmlContent);
      newWindow.document.close();
    }

    function handleAPIDocumentation(){
      ExtrasService.getApiDoc().then((response) => {
        if (response?.http_code === 200){
          openHtmlInNewWindow(response.data);
        }
      })
    }

//---------------------------------------------RENDER------------------------------------------------------//

    return (
      <>
      <SupportRequestDialog
        open={this.state.supportDialogOpen}
        onClose={() => this.toggleSupportDialog()}
        institutionID={sessionStorage.getItem(GLOBALS.SESSION_KEYS.SELECTED_INSTITUTION_ID)}
      />
      <Drawer variant="permanent" {...other}>
        <Brand>
          <Logo logo={logo} padding={'5'} width={'150px'} />
        </Brand>
        <Scrollbar>
          <List disablePadding>
            <Items>
              {routes.map((category, index) => (
                <React.Fragment key={index}>
                  {category.header ? (
                    <SidebarSection>{category.header}</SidebarSection>
                  ) : null}

                  {category.children ? (
                    <React.Fragment key={index}>
                      <SidebarCategory
                        isOpen={!this.state[index]}
                        isCollapsable={true}
                        name={getRouteLabel(tFn, category.id)}
                        icon={category.icon}
                        button={true}
                        onClick={() => this.toggle(index)}
                      />

                      <Collapse
                        in={this.state[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        {category.children.map((route, index) => (
                            route.hidden ?
                                null
                                : route.openInNewTab ? (
                          <Link
                            key={index}
                            button
                            dense
                            component="a"
                            href={route.externalUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LinkText>{getRouteLabel(tFn, route.name || route.id)}</LinkText>
                            {route.badge ? <LinkBadge label={route.badge} /> : ""}
                          </Link>
                        ) : (
                          <SidebarLink
                            key={index}
                            name={getRouteLabel(tFn, route.name || route.id)}
                            to={route.path}
                            icon={route.icon}
                            badge={route.badge}
                          />
                        )
                        ))}
                      </Collapse>
                    </React.Fragment>
                  ) : (
                    <SidebarCategory
                      isCollapsable={false}
                      name={getRouteLabel(tFn, category.id)}
                      to={category.path}
                      activeClassName="active"
                      component={NavLink}
                      icon={category.icon}
                      exact
                      badge={category.badge}
                    />
                  )}
                </React.Fragment>
              ))}
              
            </Items>
          </List>
        </Scrollbar>
        <Divider/>
        <SidebarFooter onClick={() => this.toggle(10)}>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Avatar
                alt={sessionStorage.getItem('user_first_name')}
                src="../images/user.png"
                style={{color: '#3397EF', backgroundColor: '#DDEAF6'}}
              />
            </Grid>
            <Grid item xs={9}>
              <Typography variant="body1">
                {sessionStorage.getItem('user_first_name')} {sessionStorage.getItem('user_last_name')}
              </Typography>
              <Typography variant="body2">
                {sessionStorage.getItem('username')}
              </Typography>
            </Grid>
            {/* Collapsible Arrow */}
            <Grid item xs={1}>
              <IconButton size="small" style={{ color: '#3397EF' }}>
              {this.state[10] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              <Collapse
                in={this.state[10]}
                timeout="auto"
                unmountOnExit
              >
                <Grid item xs={12}>
                  <Button
                    startIcon={<AccountBoxIcon/>}
                    onClick={(e)=> redirectTo('/my_account')}
                    disabled={!sessionStorage.getItem(GLOBALS.SESSION_KEYS.TOKEN)}
                    fullWidth
                    style={{justifyContent: "left"}}
                  >
                    {tFn('nav:sidebar.myAccount')}
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    startIcon={<HeadsetMicIcon/>}
                    onClick={this.toggleSupportDialog}
                    fullWidth
                    style={{justifyContent: "left"}}
                  >
                    {tFn('nav:sidebar.support')}
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    startIcon={<ExitToAppIcon/>}
                    onClick={(e)=> handleLogout()}
                    fullWidth
                    style={{justifyContent: "left"}}
                  >
                    {tFn('nav:sidebar.logout')}
                  </Button>
                </Grid>
              </Collapse>
            </Grid>
          </Grid>
        </SidebarFooter>
      </Drawer>
      </>
    );
  }
}
// Map Redux state to component props
const mapStateToProps = (state) => {
  const evaluatorStatus = state.routes.evaluatorStatus; // Get the evaluator status
  const userRoles = state.routes.userRoles; // Get the user roles
  
  // Check if user has only one institution
  const userInstitutions = JSON.parse(sessionStorage.getItem(GLOBALS.SESSION_KEYS.USER_INSTITUTIONS) || '[]');
  const hasOnlyOneInstitution = userInstitutions.length <= 1;
  
  // Check user roles
  const isUserManager = userRoles.includes('user_manager');
  const isClinician = userRoles.includes('clinician') || userRoles.includes('institutional_clinician');
  
  const filteredRoutes = originalMenu.filter((child) => {
    if (child.id === "Training" || child.id === "Evaluator Training") {
      // Show Training section for all evaluators regardless of training status
      return userRoles.includes("evaluator");
    }
    else if (child.id === "Demo Reports") {
      return userRoles.length > 0 ? true : !child.hidden;
    }
    else if (child.id === "Institutions") {
      // Hide Institutions if user has only one institution
      return hasOnlyOneInstitution ? false : !child.hidden;
    }
    return !child.hidden;
  });

  // Add custom menu items based on user roles and institution count
  const finalRoutes = [...filteredRoutes];
  
  // Add Admin menu item at the top if user is a user manager
  if (isUserManager) {
    const adminRoute = {
      id: "Admin",
      path: "/users",
      icon: React.createElement(SettingsOutlined),
      component: null,
      hidden: false
    };
    finalRoutes.unshift(adminRoute); // Add to the beginning of the array
  }
  
  // Add Patient List menu item for clinicians with single institution
  if (isClinician && hasOnlyOneInstitution) {
    const patientListRoute = {
      id: "Patient List",
      path: "/patients",
      icon: React.createElement(PeopleOutlined),
      component: null,
      hidden: false
    };
    
    // Add after Admin (if exists) or at the beginning
    if (isUserManager) {
      finalRoutes.splice(1, 0, patientListRoute); // Insert at position 1 (after Admin)
    } else {
      finalRoutes.unshift(patientListRoute); // Add to the beginning if no Admin
    }
  }

  // Add Resources menu item at the end
  const resourcesRoute = {
    id: "Resources",
    icon: React.createElement(FolderOpen),
    children: [
      {
        id: "ABOUT",
        path: "/about",
        icon: React.createElement(InfoIcon),
        component: null,
        hidden: false
      },
      {
        id: "User Manual", 
        path: "/user_manual",
        icon: React.createElement(MenuBook),
        component: null,
        hidden: false
      },
      {
        id: "FAQs",
        path: "/faqs",
        icon: React.createElement(HelpOutline),
        component: null,
        hidden: false
      },
      {
        id: "Brain Optimization Guideline",
        path: "/brain_optimization_guideline",
        icon: React.createElement(Memory),
        component: null,
        hidden: false,
        openInNewTab: true,
        externalUrl: BrainOptimizationGuidelinePDF
      }
    ],
    component: null,
    hidden: false
  };
  finalRoutes.push(resourcesRoute);

  return {
    routes: finalRoutes,
  };
};

// withTranslation injects the t() function as a prop into the class component
export default withRouter(connect(mapStateToProps)(withTranslation('nav')(Sidebar)));
